import { AppConfig } from './AppConfig';

const baseUrl = 'http://ec2-63-33-193-111.eu-west-1.compute.amazonaws.com';
const basePlannerUrl = 'http://w-devl-07.pulsar.be:8080';

const config: AppConfig = {
  configName: 'RUN-S2-55-v2',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/RUN-S2-55-v2/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
};

export default config;
